import Checkbox from "../../../../components/checkboxes/checkbox";
import {v4 as uuidv4} from 'uuid'

interface FilterCheckboxProps {
    fieldName: 'isInStock' | 'isExisted';
    label: string;
    dispatchGridFilter: (action: any) => void;
}

export const FilterCheckbox: React.FC<FilterCheckboxProps> = ({ fieldName, label, dispatchGridFilter }) => {
    return (
        <Checkbox
            name={`${fieldName}-${uuidv4()}`}
            label={label}
            onChange={(checked) => {
                if (checked === true) {
                    dispatchGridFilter({
                        type: 'addColumnFilter',
                        payload: {
                            name: fieldName,
                            operator: 'Eq',
                            value: true
                        },
                    });
                } else {
                    dispatchGridFilter({ type: "deleteColumnFilter", payload: fieldName });
                }
            }}
        />
    );
};